import { SvgIcon, SvgIconProps } from '@mui/material'

const NoFlightsFound = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 139 147">
        <defs>
            <linearGradient
                id="paint0_linear_43_818"
                x1="53.526"
                x2="50.014"
                y1="138.286"
                y2="120.957"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0.221" stopColor="#C7CBD3"></stop>
                <stop offset="1" stopColor="#8A94A4" stopOpacity="0.01"></stop>
            </linearGradient>
            <linearGradient
                id="paint1_linear_43_818"
                x1="46.195"
                x2="40.842"
                y1="141.614"
                y2="125.237"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0.221" stopColor="#C7CBD3"></stop>
                <stop offset="1" stopColor="#8A94A4" stopOpacity="0.01"></stop>
            </linearGradient>
            <linearGradient
                id="paint2_linear_43_818"
                x1="41.623"
                x2="37.748"
                y1="61.563"
                y2="124.238"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#C7CBD2"></stop>
                <stop offset="1" stopColor="#A4ABB6"></stop>
            </linearGradient>
            <linearGradient
                id="paint3_linear_43_818"
                x1="66.327"
                x2="80.15"
                y1="139.156"
                y2="139.065"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0.323" stopColor="#818C9D"></stop>
                <stop offset="1" stopColor="#818C9D" stopOpacity="0.4"></stop>
            </linearGradient>
            <linearGradient
                id="paint4_linear_43_818"
                x1="117.197"
                x2="130.976"
                y1="111.032"
                y2="110.942"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0.323" stopColor="#818C9D"></stop>
                <stop offset="1" stopColor="#818C9D" stopOpacity="0.4"></stop>
            </linearGradient>
            <linearGradient
                id="paint5_linear_43_818"
                x1="113.984"
                x2="116.483"
                y1="132.317"
                y2="101.866"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#ADB2BE"></stop>
                <stop offset="1" stopColor="#ADB2BE" stopOpacity="0.01"></stop>
            </linearGradient>
            <linearGradient
                id="paint6_linear_43_818"
                x1="67.917"
                x2="65.51"
                y1="79.628"
                y2="139.501"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#818C9D"></stop>
                <stop offset="1" stopColor="#A5ACB7"></stop>
            </linearGradient>
            <linearGradient
                id="paint7_linear_43_818"
                x1="67.79"
                x2="65.621"
                y1="63.362"
                y2="108.911"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#818C9D"></stop>
                <stop offset="1" stopColor="#A5ACB7"></stop>
            </linearGradient>
            <linearGradient
                id="paint8_linear_43_818"
                x1="24.173"
                x2="-16.743"
                y1="-1.176"
                y2="83.554"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#C7CBD2"></stop>
                <stop offset="1" stopColor="#A4ABB6"></stop>
            </linearGradient>
            <linearGradient
                id="paint9_linear_43_818"
                x1="76.694"
                x2="88.146"
                y1="35.311"
                y2="50.769"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#ADB2BE"></stop>
                <stop offset="1" stopColor="#ADB2BE" stopOpacity="0.01"></stop>
            </linearGradient>
            <linearGradient
                id="paint10_linear_43_818"
                x1="70.974"
                x2="82.425"
                y1="44.494"
                y2="59.953"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#ADB2BE"></stop>
                <stop offset="1" stopColor="#ADB2BE" stopOpacity="0.01"></stop>
            </linearGradient>
            <linearGradient
                id="paint11_linear_43_818"
                x1="65.212"
                x2="76.914"
                y1="53.76"
                y2="68.901"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#ADB2BE"></stop>
                <stop offset="1" stopColor="#ADB2BE" stopOpacity="0.01"></stop>
            </linearGradient>
            <linearGradient
                id="paint12_linear_43_818"
                x1="59.101"
                x2="70.469"
                y1="62.834"
                y2="78.394"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#ADB2BE"></stop>
                <stop offset="1" stopColor="#ADB2BE" stopOpacity="0.01"></stop>
            </linearGradient>
            <linearGradient
                id="paint13_linear_43_818"
                x1="53.425"
                x2="64.954"
                y1="72.229"
                y2="87.754"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#ADB2BE"></stop>
                <stop offset="1" stopColor="#ADB2BE" stopOpacity="0.01"></stop>
            </linearGradient>
            <linearGradient
                id="paint14_linear_43_818"
                x1="47.805"
                x2="59.257"
                y1="81.419"
                y2="96.877"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#ADB2BE"></stop>
                <stop offset="1" stopColor="#ADB2BE" stopOpacity="0.01"></stop>
            </linearGradient>
            <linearGradient
                id="paint15_linear_43_818"
                x1="42.043"
                x2="53.746"
                y1="90.684"
                y2="105.826"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#ADB2BE"></stop>
                <stop offset="1" stopColor="#ADB2BE" stopOpacity="0.01"></stop>
            </linearGradient>
            <linearGradient
                id="paint16_linear_43_818"
                x1="35.983"
                x2="47.435"
                y1="99.69"
                y2="115.148"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#ADB2BE"></stop>
                <stop offset="1" stopColor="#ADB2BE" stopOpacity="0.01"></stop>
            </linearGradient>
            <linearGradient
                id="paint17_linear_43_818"
                x1="30.262"
                x2="41.714"
                y1="108.969"
                y2="124.427"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#ADB2BE"></stop>
                <stop offset="1" stopColor="#ADB2BE" stopOpacity="0.01"></stop>
            </linearGradient>
            <linearGradient
                id="paint18_linear_43_818"
                x1="24.542"
                x2="35.994"
                y1="118.153"
                y2="133.611"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#ADB2BE"></stop>
                <stop offset="1" stopColor="#ADB2BE" stopOpacity="0.01"></stop>
            </linearGradient>
            <linearGradient
                id="paint19_linear_43_818"
                x1="18.136"
                x2="27.562"
                y1="125.803"
                y2="141.31"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#ADB2BE"></stop>
                <stop offset="1" stopColor="#ADB2BE" stopOpacity="0.01"></stop>
            </linearGradient>
            <linearGradient
                id="paint20_linear_43_818"
                x1="-18.695"
                x2="-39.155"
                y1="108.39"
                y2="165.796"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#BFC4CC"></stop>
                <stop offset="0.729" stopColor="#BFC4CC" stopOpacity="0.01"></stop>
            </linearGradient>
            <linearGradient
                id="paint21_linear_43_818"
                x1="51.633"
                x2="10.747"
                y1="15.081"
                y2="99.807"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#C7CBD2"></stop>
                <stop offset="1" stopColor="#A4ABB6"></stop>
            </linearGradient>
        </defs>
        <g opacity="0.7">
            <path fill="#fff" d="M135.672 101.561l-18.115-7.27 11.25-5.931 7.913-1.53-1.048 14.731z"></path>
            <path
                fill="#F3F3F3"
                fillRule="evenodd"
                d="M135.672 102.614l-18.878-8.132 11.822-6.887 8.677-1.052-1.621 16.071zm-17.162-8.419l17.257 7.462.477-14.445-7.342 1.913-10.392 5.07z"
                clipRule="evenodd"
            ></path>
            <path fill="#ADB2BE" d="M86.57 126.624l5.912 3.444v2.295l-5.912-3.634v-2.105z"></path>
            <path
                fill="url(#paint0_linear_43_818)"
                d="M58.045 142.925L13.71 117.671l7.15-4.114 44.334 25.255-7.15 4.113z"
            ></path>
            <path fill="url(#paint1_linear_43_818)" d="M57.396 142.599V147l-44.334-25.35v-4.305l44.334 25.254z"></path>
            <path fill="#DADBDE" d="M57.396 144.226l-44.334-25.351 7.15-3.922 44.334 25.255-7.15 4.018z"></path>
            <path
                fill="url(#paint2_linear_43_818)"
                d="M137.102 80.994l-71.888 52.805-45.669-26.307 4.863-12.436L93.72 56.122l43.381 24.872z"
            ></path>
            <path fill="#fff" d="M85.903 128.25l-14.206-7.653 9.916-7.174 5.911 5.166-1.62 9.661z"></path>
            <path
                fill="#F3F3F3"
                fillRule="evenodd"
                d="M86.284 129.111l-15.54-8.418 10.964-7.94 6.388 5.644-1.812 10.714zm-13.634-8.514l12.681 6.792.096-.574 1.43-8.035-5.244-4.687-8.963 6.504z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                d="M80.183 122.702l-5.53 17.697-5.34-3.156c-2.383-1.053-3.336-5.262-2.383-9.949.953-5.07 4.1-8.801 6.77-8.227.19 0 .38.032.571.095l.477.287 5.434 3.253z"
            ></path>
            <path
                fill="url(#paint3_linear_43_818)"
                fillRule="evenodd"
                d="M82.757 132.459c-1.049 5.07-3.91 8.705-6.674 8.705h-.668l-.572-.191h-.095a6.454 6.454 0 00-.667-.383l-5.053-2.869c-2.575-1.148-3.623-5.453-2.67-10.523 1.049-5.357 4.386-9.279 7.437-8.705.254.064.476.127.667.191l.572.383 4.862 2.87c.318.127.605.319.858.574h.096c1.907 1.626 2.765 5.548 1.907 9.948zm-13.253 4.305l2.956 1.722c-.127-.319-.254-.67-.381-1.052-.572-2.009-.668-4.496-.191-7.079.953-4.401 3.241-7.844 5.815-8.514l-3.717-2.2a.844.844 0 00-.382-.096h-.382c-2.287 0-4.957 3.444-5.815 7.844-.858 4.401 0 8.514 2.097 9.375z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#F3F3F3"
                fillRule="evenodd"
                d="M76.56 137.242h-.382c-.858-.191-1.62-.957-2.002-2.296-.381-1.147-.381-2.583-.095-4.113.667-3.253 2.574-5.549 4.386-5.166 1.811.383 2.764 3.157 2.097 6.409-.572 3.062-2.288 5.166-4.004 5.166zm1.525-10.81c-1.24 0-2.67 2.009-3.242 4.496-.19 1.435-.19 2.775.096 3.827.286.956.858 1.53 1.43 1.626 1.335.287 2.86-1.722 3.432-4.496.573-2.678-.19-5.166-1.525-5.453h-.19z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#F3F3F3"
                fillRule="evenodd"
                d="M76.56 137.243h-.382a1.1 1.1 0 01-.285-.192l-.859-.478.763-.287c1.144-.479 2.288-2.2 2.67-4.4.572-2.775-.191-4.879-1.24-5.262l-.667-.383.762-.382c.382-.192.763-.255 1.144-.192.954.192 1.621.957 2.003 2.296.381 1.148.381 2.583.095 4.114-.572 3.061-2.288 5.166-4.004 5.166zm1.906-10.715c.954 1.149 1.335 3.253.859 5.549-.382 1.722-1.145 3.252-2.003 4.209 1.049-.574 2.098-2.296 2.48-4.4a8.1 8.1 0 00-.096-3.731c-.286-.861-.667-1.435-1.24-1.627z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                d="M131 94.578l-5.53 17.601-5.339-3.061c-2.384-1.052-3.337-5.261-2.384-9.948 1.049-5.07 4.1-8.801 6.865-8.323.191.064.35.127.477.191l.572.287L131 94.578z"
            ></path>
            <path
                fill="url(#paint4_linear_43_818)"
                fillRule="evenodd"
                d="M133.574 104.335c-.953 5.07-3.814 8.705-6.674 8.705h-.667a191.87 191.87 0 00-.572-.191 6.196 6.196 0 01-.668-.383l-5.148-2.965c-2.479-1.053-3.623-5.357-2.575-10.427 1.049-5.357 4.386-9.28 7.437-8.706.191.064.413.128.668.192l.572.382 4.767 2.87c.317.128.635.32.953.574 1.907 1.626 2.765 5.549 1.907 9.949zm-13.252 4.305l3.05 1.722a5.327 5.327 0 01-.476-1.053c-.573-2.009-.573-4.496-.096-7.079.858-4.496 3.242-7.844 5.721-8.513l-3.623-2.2a.85.85 0 00-.382-.096 1.558 1.558 0 00-.476-.096c-2.289 0-4.863 3.54-5.816 7.94-.858 4.4.095 8.418 2.098 9.375z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#F3F3F3"
                fillRule="evenodd"
                d="M127.472 109.118h-.382c-.953-.192-1.716-1.053-2.097-2.296a9.826 9.826 0 01-.095-4.114c.667-3.252 2.574-5.548 4.385-5.165 1.907.382 2.765 3.156 2.193 6.409-.667 2.965-2.384 5.166-4.004 5.166zm1.43-10.81c-1.239 0-2.67 2.009-3.146 4.496-.286 1.435-.286 2.774.095 3.826.286.957.762 1.531 1.335 1.627 1.334.287 2.955-1.818 3.432-4.496.572-2.679-.095-5.166-1.43-5.453h-.286z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#F3F3F3"
                fillRule="evenodd"
                d="M127.472 109.118h-.381c-.191-.064-.318-.128-.382-.192l-.858-.478.763-.287c1.24-.479 2.288-2.296 2.765-4.4.477-2.775-.191-4.88-1.239-5.358l-.763-.287.763-.382c.444-.192.826-.255 1.143-.192.954.192 1.717.957 2.098 2.2.286 1.244.381 2.679.095 4.21-.667 2.965-2.383 5.166-4.004 5.166zm1.811-10.715c.954 1.149 1.335 3.253.859 5.549-.382 1.722-1.049 3.252-2.002 4.113 1.048-.478 2.097-2.2 2.478-4.304.286-1.34.286-2.679-.095-3.731-.191-.861-.667-1.435-1.24-1.627z"
                clipRule="evenodd"
            ></path>
            <path
                fill="url(#paint5_linear_43_818)"
                d="M86.57 126.624l33.751-17.984 5.435 3.348-33.274 18.08-5.912-3.444z"
            ></path>
            <path
                fill="url(#paint6_linear_43_818)"
                fillRule="evenodd"
                d="M65.3 120.888l71.793-39.89L139 88.553l-1.43 12.532-2.098 1.722-.286-.67c.191-2.678 1.144-9.088-2.955-11.096-1.24-.574-2.861-.861-4.291.095-8.485 5.07-7.723 17.028-7.723 17.219l5.34 3.253.381.287v2.869l-33.179 18.08-.477.192-.476-.192-5.911-3.731v-2.104l-.668-.095v-.957c0-2.583-1.335-5.644-4.48-6.984-1.272-.509-2.734-.223-4.386.861-7.437 4.879-6.865 18.081-6.865 18.176v.478l-4.958 2.583-.953-.574v-12.053l1.716-7.557zm27.078 8.896l18.591-10.14 13.729-7.461-4.576-2.87-32.797 17.506 2.097 1.243 2.956 1.722zm-5.53-1.148l5.053 3.157v-1.244l-2.765-1.626-2.288-1.339v1.052z"
                clipRule="evenodd"
            ></path>
            <path fill="url(#paint7_linear_43_818)" d="M92.882 64.54l26.028 14.732-54.25 30.994L92.882 64.54z"></path>
            <path
                fill="#DADBDE"
                d="M0 116.58c.095-3.922 2.479-8.322 5.434-10.044l10.202-5.74 56.06-89.634c.382-.638.795-1.244 1.24-1.818l.477-.478.096-.096.38-.382.096-.096c.127-.064.254-.16.381-.287.064-.064.128-.096.191-.096.064-.063.159-.127.286-.191.064-.064.159-.128.286-.191 0-.064.032-.096.096-.096L87.333.639c1.335-.765 2.574-.86 3.528-.191l4.767 2.774-3.91 5.453c-.857 2.295-2.288 4.4-4.004 5.548l-53.2 74.329-.763.956-13.157 21.046a1.124 1.124 0 01-.286.382l-.382.574-.095.096-.381.383c0 .063-.032.127-.096.191l-.381.382-.095.096a1.49 1.49 0 01-.382.287l-.19.191a1.108 1.108 0 01-.286.192l-.191.191-.381.191-.096.096-5.434 3.061-5.34 6.696-4.576-2.582a4.808 4.808 0 01-.476-.287C.572 119.928 0 118.493 0 116.58z"
            ></path>
            <path
                fill="url(#paint8_linear_43_818)"
                d="M10.107 109.31l10.297-5.835 55.965-89.634c.381-.638.794-1.212 1.24-1.722h.095a3.12 3.12 0 01.381-.478l.096-.096.38-.383.096-.095a1.49 1.49 0 01.382-.287l.19-.192c.064-.063.16-.127.286-.191a1.11 1.11 0 01.286-.191h.096l12.108-6.888c2.956-1.626 5.244.191 5.244 4.018-.095 3.922-2.479 8.418-5.34 10.044l-10.296 5.74-56.347 90.208c-.064.064-.127.16-.19.287l-.096.096a3.125 3.125 0 01-.381.478c0 .064-.032.096-.096.096-.063.191-.159.35-.286.478-.063 0-.127.032-.19.096a1.515 1.515 0 00-.287.382l-.19.192a1.466 1.466 0 00-.382.287l-.095.095a1.466 1.466 0 01-.381.287c-.064.064-.128.096-.191.096l-.286.287h-.19l-12.11 6.887c-2.86 1.627-5.243-.191-5.148-4.017 0-3.922 2.384-8.418 5.34-10.045z"
            ></path>
            <path
                fill="#F3F3F3"
                d="M92.958 12.884l17.543 10.235-10.869 8.514-20.403-11.67 13.73-7.08zM98.679 37.373L93.53 40.53 73.508 29.242l5.721-3.253 19.45 11.384zM92.863 46.556l-5.149 3.253-20.022-11.384 5.817-3.253 19.354 11.384zM86.856 55.74l-5.148 3.157-20.022-11.384 5.816-3.157L86.856 55.74zM81.136 64.923l-5.244 3.252-19.927-11.383 5.816-3.252 19.355 11.383zM75.51 74.298l-5.148 3.157-20.117-11.384 5.816-3.252 19.45 11.48zM69.695 83.482l-5.149 3.156-20.022-11.383 5.817-3.253 19.354 11.48zM63.688 92.57l-5.148 3.252-20.022-11.383 5.816-3.253 19.354 11.383zM57.968 101.753l-5.244 3.253-19.927-11.384 5.72-3.252 19.45 11.383zM52.248 111.032l-5.149 3.157-20.022-11.383 5.72-3.253 19.45 11.479zM46.431 120.216l-5.148 3.156-20.022-11.383 5.816-3.253 19.354 11.48z"
            ></path>
            <path
                fill="url(#paint9_linear_43_818)"
                d="M99.632 31.634l-.954 5.74-19.45-11.385v-6.026l20.404 11.67z"
            ></path>
            <path
                fill="url(#paint10_linear_43_818)"
                d="M93.912 40.817l-1.049 5.74-19.355-11.384v-6.027l20.404 11.671z"
            ></path>
            <path
                fill="url(#paint11_linear_43_818)"
                d="M87.714 49.81l-.763 5.93-19.354-11.383V38.33l20.117 11.48z"
            ></path>
            <path
                fill="url(#paint12_linear_43_818)"
                d="M82.184 59.088l-1.048 5.835L61.782 53.54l-.096-6.027 20.498 11.575z"
            ></path>
            <path
                fill="url(#paint13_linear_43_818)"
                d="M76.464 68.463l-.954 5.835-19.45-11.48-.095-6.026 20.499 11.67z"
            ></path>
            <path
                fill="url(#paint14_linear_43_818)"
                d="M70.743 77.646l-1.048 5.836-19.355-11.48v-5.93l20.403 11.574z"
            ></path>
            <path
                fill="url(#paint15_linear_43_818)"
                d="M64.546 86.638l-.763 6.027-19.354-11.48.096-5.93 20.021 11.383z"
            ></path>
            <path
                fill="url(#paint16_linear_43_818)"
                d="M58.921 96.013l-.953 5.74-19.45-11.384v-6.027l20.403 11.671z"
            ></path>
            <path
                fill="url(#paint17_linear_43_818)"
                d="M53.2 105.197l-.953 5.835-19.45-11.48v-5.93l20.404 11.575z"
            ></path>
            <path
                fill="url(#paint18_linear_43_818)"
                d="M47.48 114.38l-1.049 5.835-19.354-11.479v-5.931l20.404 11.575z"
            ></path>
            <path
                fill="url(#paint19_linear_43_818)"
                d="M41.283 123.372l-.668 4.688-19.45-11.384.096-4.687 20.022 11.383z"
            ></path>
            <path
                fill="url(#paint20_linear_43_818)"
                d="M40.616 128.059L28.03 135.33 8.104 123.946l13.062-7.27 19.45 11.383z"
            ></path>
            <path
                fill="#DADBDE"
                d="M27.554 132.843c0-3.922 2.383-8.418 5.339-10.044l10.297-5.74 56.06-89.73a8.12 8.12 0 011.145-1.722h.095c.127-.191.254-.35.382-.479l.095-.095.381-.383.095-.095c.128-.128.255-.224.382-.287l.191-.192c.127-.064.222-.127.286-.191.063-.064.159-.128.286-.191h.095l12.108-6.888c1.335-.765 2.575-.765 3.528-.191l4.767 2.87-3.814 5.357c-.857 2.391-2.383 4.4-4.099 5.643l-53.105 74.233-.859 1.053-13.157 21.045a1.11 1.11 0 01-.19.287l-.096.096c-.127.191-.254.35-.381.478v.096c-.127.191-.255.35-.382.478-.063.064-.127.096-.19.096a1.496 1.496 0 01-.286.382l-.19.192a1.49 1.49 0 00-.382.287c0 .064-.032.095-.095.095a1.499 1.499 0 01-.382.287l-.19.191a1.128 1.128 0 00-.286.192h-.192l-5.434 3.157-5.339 6.696-4.481-2.678a3.682 3.682 0 01-.477-.192c-.953-.765-1.62-2.2-1.525-4.113z"
            ></path>
            <path
                fill="url(#paint21_linear_43_818)"
                d="M37.565 125.573l10.297-5.836 56.061-89.634c.381-.638.794-1.244 1.239-1.818l.477-.478c.127-.191.254-.319.381-.383l.191-.19c.063-.065.159-.16.286-.288.064 0 .127-.032.191-.096.127-.063.222-.127.286-.19.127-.065.222-.128.286-.192.063 0 .095-.032.095-.096l12.108-6.792c2.956-1.626 5.339.096 5.244 4.018 0 3.826-2.384 8.322-5.339 10.044l-10.297 5.74-56.347 90.208c-.063.064-.127.16-.19.287l-.382.574c-.063 0-.096.032-.096.096a3.124 3.124 0 00-.38.478c-.064 0-.096.032-.096.096l-.381.383c-.064.063-.128.095-.191.095a1.492 1.492 0 01-.286.383c-.064 0-.127.032-.19.096a1.465 1.465 0 00-.382.287c-.063 0-.127.031-.19.095a1.077 1.077 0 01-.287.191 38.46 38.46 0 00-.095.096l-12.109 6.792c-2.955 1.722-5.243-.096-5.243-4.018 0-3.826 2.479-8.322 5.339-9.948z"
            ></path>
        </g>
    </SvgIcon>
)

export default NoFlightsFound
